import React, {useEffect} from 'react';
import {BrowserRouter, Route, Routes, useLocation} from 'react-router-dom';
import {useTheme} from './hooks/useTheme';
import {LoadingScreen} from './components/LoadingScreen';
import {Navbar} from './components/Navbar';
import {Footer} from './components/Footer';
import {CookieBanner} from './components/CookieBanner';
import {HomePage} from './pages/HomePage';
import {WycenaPage} from './pages/WycenaPage';
import {PrivacyPage} from './pages/PrivacyPage';
import {KontaktPage} from './pages/KontaktPage';
import {KalkulatorPage} from './pages/KalkulatorPage';
import {WykonaniaPage} from './pages/WykonaniaPage';
import {BlokadaReklamPage} from './pages/BlokadaReklamPage';
import './index.css';

function ScrollToTop() {
    const {pathname} = useLocation();
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
}

function AppContent() {
    const [theme, setTheme] = useTheme();

    return (
        <>
            <ScrollToTop/>
            <LoadingScreen theme={theme}/>
            <Navbar theme={theme} setTheme={setTheme}/>
            <main className="min-h-screen flex flex-col pt-[var(--navbar-height)] md:pt-[var(--navbar-height-desktop)]">
                <Routes>
                    <Route path="/" element={<HomePage/>}/>
                    <Route path="/wycena" element={<WycenaPage/>}/>
                    <Route path="/wykonania" element={<WykonaniaPage/>}/>
                    <Route path="/kalkulator" element={<KalkulatorPage/>}/>
                    <Route path="/blokada-reklam" element={<BlokadaReklamPage/>}/>
                    <Route path="/kontakt" element={<KontaktPage/>}/>
                    <Route path="/polityka-prywatnosci" element={<PrivacyPage/>}/>
                </Routes>
            </main>
            <Footer/>
            <CookieBanner/>
        </>
    );
}

function App() {
    return (
        <BrowserRouter>
            <AppContent/>
        </BrowserRouter>
    );
}

export default App;
